import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinance = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52.691,
	height: 52.579,
	viewBox: "0 0 52.691 52.579",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "finance",
		transform: "translate(0.508 0.497)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68797",
				"data-name": "Path 68797",
				d: "M592.858,167.9c-.947,1-1.862,2.038-2.857,2.99-.384.367-1,.829-1.417.752-.826-.152-.613-1.017-.615-1.638-.014-4.176.009-8.353-.027-12.529a3.514,3.514,0,0,0-.44-1.645,9.446,9.446,0,0,1,4.8-13.453,1.1,1.1,0,0,0,.874-1.255c-.046-1.758-.015-3.517-.015-5.436h-3.278c-.866,0-1.733.009-2.6-.007-.779-.014-1.091-.436-1.032-1.2a7.777,7.777,0,0,1,7.895-7.391q11.044-.04,22.089,0c4.63.016,7.918,3.435,7.923,8.207q.017,16.706,0,33.412v1.325h1.172q5.569,0,11.137,0c1.338,0,1.588.291,1.419,1.6a7.747,7.747,0,0,1-7.879,7q-14.479.029-28.957,0a7.717,7.717,0,0,1-7.893-7.938q0-1.319,0-2.637Zm8.63-24.487a11.732,11.732,0,0,1,3.382,5.177h1.192c2.815,0,5.63-.017,8.444.024a1.444,1.444,0,0,1,.949.538.848.848,0,0,1-.17.813,1.733,1.733,0,0,1-1.012.3c-2.691.023-5.382.012-8.073.015-.327,0-.653.029-.808.036-.343,1.787-.66,3.433-.988,5.139h2.53q3.8,0,7.609,0c.586,0,1.054.251.936.842-.065.326-.534.621-.885.819-.212.12-.544.032-.823.032H603.516v5.177h1.058q4.964,0,9.929,0c.573,0,.993.182,1.011.811s-.385.862-.958.875q-.371.008-.742.008H603.459c0,2.208.029,4.3-.025,6.4-.011.422-.245,1.071-.543,1.187s-.832-.258-1.227-.48a3.039,3.039,0,0,1-.6-.579l-5.233-5.359-.4.064a6.711,6.711,0,0,0-.511,1.6c-.077,1.232.059,2.48-.041,3.709a6.061,6.061,0,0,0,6.237,6.349c7.733-.033,15.466-.009,23.2-.013.244,0,.487-.053.876-.1a8.338,8.338,0,0,1-2.787-6.6q.039-17.353.007-34.706a8.743,8.743,0,0,0-.123-1.842,5.983,5.983,0,0,0-6.064-4.824,6.052,6.052,0,0,0-5.857,5.52c-.165,1.268-.245,1.341-1.571,1.341q-6.357,0-12.713,0h-1.121v6.035h1.167q9.14,0,18.28,0c.591,0,1.082.121,1.1.815s-.459.876-1.053.877q-1.345,0-2.691,0Zm-13.51,7.777a7.747,7.747,0,1,0,7.578-7.777A7.776,7.776,0,0,0,587.978,151.186Zm.115-17.284h20.59a8.393,8.393,0,0,1,2.644-4.967,1.872,1.872,0,0,0-.33-.1c-5.776-.006-11.552-.081-17.326.019A5.732,5.732,0,0,0,588.093,133.9Zm1.646,34.815c.351-.328.577-.527.79-.74q2.068-2.063,4.133-4.129c.906-.9,1.174-.9,2.05-.034q2.174,2.154,4.35,4.305c.177.175.384.319.658.544V158.487a9.69,9.69,0,0,1-11.98,0Zm34.552,3.1a5.963,5.963,0,0,0,11.793,0Z",
				transform: "translate(-586.243 -127.061)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68798",
				"data-name": "Path 68798",
				d: "M744.719,145.9a4.789,4.789,0,0,1,4.583,4.333c.006.243-.228.491-.35.737-.172-.205-.458-.391-.5-.619-.382-2.209-1.3-3.139-3.58-3.613-.252-.052-.465-.295-.7-.449Z",
				transform: "translate(-714.86 -142.4)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68799",
				"data-name": "Path 68799",
				d: "M622.281,245.019a3.37,3.37,0,0,1-3.374-3.428,3.466,3.466,0,0,1,3.417-3.43,3.539,3.539,0,0,1,3.455,3.424A3.439,3.439,0,0,1,622.281,245.019Zm-.081-1.691a1.725,1.725,0,0,0,1.82-1.591,1.672,1.672,0,0,0-1.578-1.814,1.738,1.738,0,0,0-1.836,1.573A1.761,1.761,0,0,0,622.2,243.328Z",
				transform: "translate(-612.843 -217.537)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			})
		]
	})
});
export default SvgFinance;
